/** Path2D strict validators: the `curve` resource reference format. */
// Registration happens on import, so a test that loads only this slice
// resolves an inherited key only when this line imports the ancestor.
import '../../base/node2d/linterParser.js';
import { validatorRegistry } from '../../../linter/ValidatorRegistry.js';
import { v } from '../../../linter/validators/index.js';
validatorRegistry.registerAll('Path2D', {
    curve: v.resourceReference('curve'),
});
//# sourceMappingURL=linterParser.js.map